import React from 'react';

type Props = {
    values: Array<number>;
    width?: number;
    height?: number;
    color?: string;
    maxValue?: number;
};

export function Sparkline({ values, width = 96, height = 28, color = '#34C759', maxValue }: Props) {
    const padding = 2;
    const maxChartValue = Math.max(maxValue ?? Math.max(...values, 1), 1);
    const step = values.length > 1 ? (width - padding * 2) / (values.length - 1) : 0;

    const points = values.map((value, index) => {
        const x = padding + step * index;
        const clampedValue = Math.min(value, maxChartValue);
        const y = height - padding - ((clampedValue / maxChartValue) * (height - padding * 2));
        return `${x},${y}`;
    }).join(' ');

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role='img' aria-label='User activity sparkline'>
            <polyline
                points={points}
                fill='none'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
